import React from "react"
import SaleStage from "../components/SaleStage"

class Step4SS extends React.Component {
    render() {
        const { client, updateClient } = this.props;
        const { houseConstruction={} } = (client && client.stages_of_sale) || {};

        const {
            clearedSpotCashSpotDpAndMf,
            forInstallmentClearedDpAndMfSixMonthsBeforeEndOf20Equity,
            cmap,
            buildingPermitRequest,
            buildingPermitRequestDate,
            approvedEndorsement,
            dateEndorseToEngineering,
            dateAwardedToContractor,
            contractor,
            isCompleted,
            completionDate,
            others=[]
        } = houseConstruction;

        const step4Fields = [
            { key: 'clearedSpotCashSpotDpAndMf', type: 'toggle', label: 'Cleared Spot Cash Spot DP And MF', value: clearedSpotCashSpotDpAndMf},
            { key: 'forInstallmentClearedDpAndMfSixMonthsBeforeEndOf20Equity', type: 'toggle', label: 'For Installment Cleared DP And MF Six Months Before End Of Equity', value: forInstallmentClearedDpAndMfSixMonthsBeforeEndOf20Equity},
            { key: 'cmap', type: 'file', label: 'CMAP', value: cmap},
            { key: 'buildingPermitRequest', type: 'file', label: 'Building Permit Request', value: buildingPermitRequest},
            { key: 'buildingPermitRequestDate', type: 'date', label: 'Building Permit Request Date', value: buildingPermitRequestDate},
            { key: 'approvedEndorsement', type: 'file', label: 'Approved Signed Endorsement for Construction', value: approvedEndorsement},
            { key: 'dateEndorseToEngineering', type: 'date', label: 'Date Endorse to Engineering Team for House Construction', value: dateEndorseToEngineering},
            { key: 'dateAwardedToContractor', type: 'date', label: 'Date Awarded to Contractor', value: dateAwardedToContractor},
            { key: 'contractor', type: 'text', label: 'Contractor', value: contractor},
        ]

        return (
            !!client ? <SaleStage 
                title="House Construction"
                fields={step4Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="houseConstruction"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default Step4SS
